import { defineStore } from 'pinia'
import { SwapStep } from '../types'
import type { SwapType } from '../types'

interface State {
  isOpenSwapModal: boolean
  swapId?: string
  step: SwapStep
  swapType?: SwapType
  isLoading: boolean
}

const INITIAL_STATE: State = {
  isOpenSwapModal: false,
  swapId: undefined,
  step: SwapStep.Select,
  swapType: undefined,
  isLoading: false,
}

const useSwapStore = defineStore('swap', {
  state: () => ({ ...INITIAL_STATE }),
  getters: {
    getUppercaseSwapType: (state) => {
      if (state.swapType) {
        return state.swapType.charAt(0).toUpperCase() + state.swapType.slice(1)
      }
      return state.swapType
    },
  },
  actions: {
    toggleSwapModal(isOpen: boolean) {
      this.isOpenSwapModal = isOpen
    },
    setSwapId(swapId: string) {
      this.swapId = swapId
    },
    resetSwapState() {
      this.isOpenSwapModal = false
      this.swapId = undefined
      this.step = SwapStep.Select
    },
    setStep(step: SwapStep) {
      this.step = step
    },
    setSwapType(type: SwapType) {
      this.swapType = type
    },
    toggleIsLoading(isLoading: boolean) {
      this.isLoading = isLoading
    },
  },
})

export default useSwapStore
